// extracted by mini-css-extract-plugin
export default {"page":"pN","wrapper":"qN","text":"rN","icons":"sN","icon":"tN","icon_text":"uN","carousel_wrapper":"vN","slide":"wN","image":"xN","arrows":"yN","prev":"zN","modal_root":"AN","x_mark":"BN","modal":"CN","images":"EN","main_image":"FN","name":"GN"};
    if(module.hot) {
      // 1715188237405
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  